import { createSlice } from '@reduxjs/toolkit';

import { normalizeBy } from 'utils';

const initialState = {
	contactOrders: {},
};

export const order = createSlice({
	name: 'order',
	initialState,
	reducers: {
		changeContactOrder: (state, { payload }) => {
			const { id, orderedLeads } = payload;

			return {
				contactOrders: {
					...state.contactOrders,
					[id]: {
						...state.contactOrders[id],
						orderedLeads,
					},
				},
			};
		},
		saveContactOrder: (state, { payload }) => {
			return {
				contactOrders: {
					...normalizeBy(payload, 'id'),
				},
			};
		},
		reset: () => initialState,
	},
});

export default order.reducer;
export const REDUCER_NAME = order.name;

export const { changeContactOrder, saveContactOrder, reset } = order.actions;
